/* =========================================================
   SPA BOOKING MODAL — ApoloPets
   FIX DEFINITIVO CLICK "Agendar cita"
========================================================= */

/* ==========================
CONFIGURACIÓN
========================== */
const WORKDAY_START = "09:00";
const WORKDAY_END   = "19:00";
const SLOT_MINUTES  = 120;
const STORAGE_KEY   = "spaBookings";
const WHATSAPP      = "573164584642";

/* ==========================
HELPERS
========================== */
const qs  = s => document.querySelector(s);
const qsa = s => Array.from(document.querySelectorAll(s));

function timeToMinutes(t) {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}

function minutesToTime(m) {
  const h = String(Math.floor(m / 60)).padStart(2, "0");
  const min = String(m % 60).padStart(2, "0");
  return `${h}:${min}`;
}

function getBookings() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
}

function saveBooking(booking) {
  const all = getBookings();
  all.push(booking);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

/* ==========================
MODAL ELEMENTS
========================== */
const overlay = qs("#spa-booking-overlay");
const modal   = qs(".spa-booking-modal");

if (!overlay || !modal) {
  console.warn("SPA Booking Modal: HTML no encontrado");
}

/* ==========================
OPEN / CLOSE MODAL
========================== */
function openModal() {
  overlay.hidden = false;
  modal.focus();
}

function closeModal() {
  overlay.hidden = true;
}

/* =========================================================
   🔥 FIX CLAVE: ENGANCHE POR href="#agendar"
========================================================= */
document.addEventListener("click", function (e) {
  const agendarBtn = e.target.closest('a[href="#agendar"]');

  if (agendarBtn) {
    e.preventDefault();
    openModal();
    return;
  }

  if (
    e.target === overlay ||
    e.target.closest(".spa-booking-close") ||
    e.target.closest(".spa-close-btn")
  ) {
    closeModal();
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    closeModal();
  }
});

/* ==========================
HORARIOS
========================== */
const dateInput = qs("#spa-date");
const slotsBox  = qs("#spa-slots");
let selectedTime = null;

if (dateInput) {
  dateInput.addEventListener("change", renderSlots);
}

function renderSlots() {
  slotsBox.innerHTML = "";
  selectedTime = null;

  const date = dateInput.value;
  if (!date) {
    slotsBox.innerHTML = `<p class="spa-slots-empty">Selecciona una fecha</p>`;
    return;
  }

  const bookings = getBookings().filter(b => b.date === date);

  let start = timeToMinutes(WORKDAY_START);
  const end = timeToMinutes(WORKDAY_END);

  while (start + SLOT_MINUTES <= end) {
    const time = minutesToTime(start);
    const occupied = bookings.some(b => b.time === time);

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "spa-slot";
    btn.textContent = occupied ? `${time} (Ocupado)` : time;

    if (occupied) {
      btn.disabled = true;
    } else {
      btn.addEventListener("click", () => {
        qsa(".spa-slot").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        selectedTime = time;
      });
    }

    slotsBox.appendChild(btn);
    start += SLOT_MINUTES;
  }
}

/* ==========================
FORM SUBMIT
========================== */
const form = qs("#spa-booking-form");

if (form) {
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const error = qs("#spa-error");
    error.hidden = true;

    const date    = dateInput.value;
    const service = qs("#spa-service").value;

    if (!date || !service || !selectedTime) {
      error.textContent = "Completa fecha, servicio y horario.";
      error.hidden = false;
      return;
    }

    const exists = getBookings().some(
      b => b.date === date && b.time === selectedTime
    );

    if (exists) {
      error.textContent = "Ese horario ya está agendado, por favor elige otro.";
      error.hidden = false;
      renderSlots();
      return;
    }

    const booking = {
      date,
      time: selectedTime,
      service,
      name: qs("#spa-name").value,
      phone: qs("#spa-phone").value,
      pet: qs("#spa-pet").value
    };

    saveBooking(booking);
    showConfirmation(booking);
  });
}

/* ==========================
CONFIRMACIÓN
========================== */
function showConfirmation(b) {
  qs("#spa-booking-form").hidden = true;
  const conf = qs("#spa-confirmation");
  conf.hidden = false;

  qs("#spa-summary").innerHTML = `
    <p><strong>Servicio:</strong> ${b.service}</p>
    <p><strong>Fecha:</strong> ${b.date}</p>
    <p><strong>Hora:</strong> ${b.time}</p>
    <p><strong>Duración:</strong> 2 horas</p>
  `;

  const msg = encodeURIComponent(
`TU NUEVA RESERVA
Servicio: ${b.service}
Fecha: ${b.date}
Hora: ${b.time}
Nombre: ${b.name || "-"}
Teléfono: ${b.phone || "-"}
Mascota: ${b.pet || "-"}`
  );

  qs("#spa-whatsapp").href = `https://wa.me/${WHATSAPP}?text=${msg}`;
}
